module.exports = __webpack_public_path__ + "img/mc.749e995c.svg";